import styled, { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  html, body, #root {    
    width: 100%;    
    height: auto;  
    margin: 0;    
    background: #000;
    color: #fff;
    font-family: 'Inter', Arial, sans-serif;
  }
`;

export const Row = styled.div<{ width?: string, height?: string }>`
  width: ${({ width }) => width || "100%"};
  height: ${({ height }) => height || "100%"};
  display: flex;  
  justify-content: center;
`;

export const Container = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;    
  color: #fff;
  justify-content: center;
  align-items: center;
`;


export const RowCenter = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
